import { Container } from 'react-bootstrap';
import CustomAccordion from '../../components/Accordion/CustomAccordion';
import { AppSection, AppTitle } from '../Conditions/Conditions';

const Questions = () => {

  const QuestionsItems = [
    {
      title: 'Может ли человек без опыта в бизнесе построить успешную сеть в своем городе?',
      content: 'Конечно! Единственное что требуется от партнера -  расставлять терминалы, никаких специфических умений и навыков для этого не требуется'
    },
    {
      title: 'Сколько времени нужно для запуска?',
      content: 'Как правило, расстановка всех терминалов занимает у партнеров не более 1 месяца'
    },
    {
      title: 'Сколько времени требует данный бизнес?',
      content: 'Со второго месяца  - не более 2 часов в неделю'
    },
    {
      title: 'Какие есть расходы?',
      content: 'Расходы в этом бизнесе минимальны: Сим-карта - до 100 руб/мес на один терминал и налоги'
    }
  ];

  return (
    <AppSection className='faq'>
      <Container>
        <AppTitle>Часто задаваемые вопросы</AppTitle>
        {QuestionsItems.map(el => <CustomAccordion key={el.title} title={el.title} content={el.content} /> )}
      </Container>
    </AppSection>
  );
};

export default Questions;